/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/BusinessSimulatorCashflowCapitalItemValue', 'model/BusinessSimulatorCashflowCapitalItemValuePaginationSlice'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/BusinessSimulatorCashflowCapitalItemValue'), require('../model/BusinessSimulatorCashflowCapitalItemValuePaginationSlice'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.BusinessSimulatorCashflowCapitalItemValueApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.BusinessSimulatorCashflowCapitalItemValue, root.ForStractionServiceApi.BusinessSimulatorCashflowCapitalItemValuePaginationSlice);
  }
}(this, function(ApiClient, BusinessSimulatorCashflowCapitalItemValue, BusinessSimulatorCashflowCapitalItemValuePaginationSlice) {
  'use strict';

  /**
   * BusinessSimulatorCashflowCapitalItemValue service.
   * @module api/BusinessSimulatorCashflowCapitalItemValueApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new BusinessSimulatorCashflowCapitalItemValueApi. 
   * @alias module:api/BusinessSimulatorCashflowCapitalItemValueApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the businessSimulatorCashflowCapitalItemValueAddAllPut operation.
     * @callback module:api/BusinessSimulatorCashflowCapitalItemValueApi~businessSimulatorCashflowCapitalItemValueAddAllPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<'Integer'>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * addAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/BusinessSimulatorCashflowCapitalItemValue>} body 
     * @param {module:api/BusinessSimulatorCashflowCapitalItemValueApi~businessSimulatorCashflowCapitalItemValueAddAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<'Integer'>}
     */
    this.businessSimulatorCashflowCapitalItemValueAddAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling businessSimulatorCashflowCapitalItemValueAddAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling businessSimulatorCashflowCapitalItemValueAddAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ['Integer'];

      return this.apiClient.callApi(
        '/BusinessSimulatorCashflowCapitalItemValue/addAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessSimulatorCashflowCapitalItemValueCopyCapitalItemValuesFromScenarioGet operation.
     * @callback module:api/BusinessSimulatorCashflowCapitalItemValueApi~businessSimulatorCashflowCapitalItemValueCopyCapitalItemValuesFromScenarioGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * copyCapitalItemValuesFromScenario
     * @param {String} _4SAPIAppID 
     * @param {Integer} sourceScenarioID 
     * @param {Integer} targetScenarioID 
     * @param {module:api/BusinessSimulatorCashflowCapitalItemValueApi~businessSimulatorCashflowCapitalItemValueCopyCapitalItemValuesFromScenarioGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.businessSimulatorCashflowCapitalItemValueCopyCapitalItemValuesFromScenarioGet = function(_4SAPIAppID, sourceScenarioID, targetScenarioID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling businessSimulatorCashflowCapitalItemValueCopyCapitalItemValuesFromScenarioGet";
      }

      // verify the required parameter 'sourceScenarioID' is set
      if (sourceScenarioID == undefined || sourceScenarioID == null) {
        throw "Missing the required parameter 'sourceScenarioID' when calling businessSimulatorCashflowCapitalItemValueCopyCapitalItemValuesFromScenarioGet";
      }

      // verify the required parameter 'targetScenarioID' is set
      if (targetScenarioID == undefined || targetScenarioID == null) {
        throw "Missing the required parameter 'targetScenarioID' when calling businessSimulatorCashflowCapitalItemValueCopyCapitalItemValuesFromScenarioGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'sourceScenarioID': sourceScenarioID,
        'targetScenarioID': targetScenarioID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/BusinessSimulatorCashflowCapitalItemValue/copyCapitalItemValuesFromScenario', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessSimulatorCashflowCapitalItemValueDeleteAllPut operation.
     * @callback module:api/BusinessSimulatorCashflowCapitalItemValueApi~businessSimulatorCashflowCapitalItemValueDeleteAllPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * deleteAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/Integer>} body 
     * @param {module:api/BusinessSimulatorCashflowCapitalItemValueApi~businessSimulatorCashflowCapitalItemValueDeleteAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.businessSimulatorCashflowCapitalItemValueDeleteAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling businessSimulatorCashflowCapitalItemValueDeleteAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling businessSimulatorCashflowCapitalItemValueDeleteAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/BusinessSimulatorCashflowCapitalItemValue/deleteAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessSimulatorCashflowCapitalItemValueEditAllPut operation.
     * @callback module:api/BusinessSimulatorCashflowCapitalItemValueApi~businessSimulatorCashflowCapitalItemValueEditAllPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * editAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/BusinessSimulatorCashflowCapitalItemValue>} body 
     * @param {module:api/BusinessSimulatorCashflowCapitalItemValueApi~businessSimulatorCashflowCapitalItemValueEditAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.businessSimulatorCashflowCapitalItemValueEditAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling businessSimulatorCashflowCapitalItemValueEditAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling businessSimulatorCashflowCapitalItemValueEditAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/BusinessSimulatorCashflowCapitalItemValue/editAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessSimulatorCashflowCapitalItemValueSearchSlicePut operation.
     * @callback module:api/BusinessSimulatorCashflowCapitalItemValueApi~businessSimulatorCashflowCapitalItemValueSearchSlicePutCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BusinessSimulatorCashflowCapitalItemValuePaginationSlice} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * searchSlice
     * @param {String} _4SAPIAppID 
     * @param {module:model/BusinessSimulatorCashflowCapitalItemValue} body 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.startID  (default to 0)
     * @param {Integer} opts.maxCount  (default to 0)
     * @param {Integer} opts.slicingOrder  (default to 0)
     * @param {module:api/BusinessSimulatorCashflowCapitalItemValueApi~businessSimulatorCashflowCapitalItemValueSearchSlicePutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BusinessSimulatorCashflowCapitalItemValuePaginationSlice}
     */
    this.businessSimulatorCashflowCapitalItemValueSearchSlicePut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling businessSimulatorCashflowCapitalItemValueSearchSlicePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling businessSimulatorCashflowCapitalItemValueSearchSlicePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'startID': opts['startID'],
        'maxCount': opts['maxCount'],
        'slicingOrder': opts['slicingOrder']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = BusinessSimulatorCashflowCapitalItemValuePaginationSlice;

      return this.apiClient.callApi(
        '/BusinessSimulatorCashflowCapitalItemValue/searchSlice', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
